import React from 'react'
import ReactPlayer from 'react-player'
import video from "../Manual/IndicadoresAyB.mp4"

function IndicadorMorbilidadManual() {
  return (
    <div>
        <center>
<ReactPlayer
url={require("../Manual/GrupoMorbilidad.mp4")}
width="50%"
height="50%"
controls
playing
muted
loop


/>
</center>
    </div>
  )
}

export default IndicadorMorbilidadManual